import { createFeatureSelector } from '@ngrx/store';
import { createApiCallSelectors } from '../../../../common/store/generic.selectors';
import {
  SalesPersonCommissionModel,
  commissionFeatureKey,
  SalesPersonCommissionListModel,
} from './types';
import { ICommissionState } from './commission.reducer';

const commissionFeatureState =
  createFeatureSelector<ICommissionState>(commissionFeatureKey);

export const commissionSelectors = {
  getById: createApiCallSelectors<number, ICommissionState>(
    commissionFeatureState,
    'getById',
  ),
  getCommissionsPreview: createApiCallSelectors<void, ICommissionState>(
    commissionFeatureState,
    'getCommissionsPreview',
  ),
  add: createApiCallSelectors<void, ICommissionState>(
    commissionFeatureState,
    'add',
  ),
  addSalesPersonCommissionPayment: createApiCallSelectors<
    SalesPersonCommissionListModel,
    ICommissionState
  >(commissionFeatureState, 'addSalesPersonCommissionPayment'),
  deleteSalesPersonCommissions: createApiCallSelectors<
    SalesPersonCommissionListModel,
    ICommissionState
  >(commissionFeatureState, 'deleteSalesPersonCommissions'),
  deleteSalesPersonCommissionPayment: createApiCallSelectors<
    number[],
    ICommissionState
  >(commissionFeatureState, 'deleteSalesPersonCommissionPayment'),

  getCompanyCommissions: createApiCallSelectors<void, ICommissionState>(
    commissionFeatureState,
    'getCompanyCommissions',
  ),
  getExcludedTaxAnnualFees: createApiCallSelectors<void, ICommissionState>(
    commissionFeatureState,
    'getExcludedTaxAnnualFees',
  ),
  getApplicationFeesReport: createApiCallSelectors<void, ICommissionState>(
    commissionFeatureState,
    'getApplicationFeesReport',
  ),
  getSalesPersonProductionDashboardData: createApiCallSelectors<
    void,
    ICommissionState
  >(commissionFeatureState, 'getSalesPersonProductionDashboardData'),
  getSalesPersonCommissionsDashboardData: createApiCallSelectors<
    void,
    ICommissionState
  >(commissionFeatureState, 'getSalesPersonCommissionsDashboardData'),
};
